/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetSupplierReference
 */
export interface SetSupplierReference {
    /**
     * 
     * @type {string}
     * @memberof SetSupplierReference
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SetSupplierReference
     */
    newClientReference?: string;
}

/**
 * Check if a given object implements the SetSupplierReference interface.
 */
export function instanceOfSetSupplierReference(value: object): value is SetSupplierReference {
    return true;
}

export function SetSupplierReferenceFromJSON(json: any): SetSupplierReference {
    return SetSupplierReferenceFromJSONTyped(json, false);
}

export function SetSupplierReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSupplierReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'newClientReference': json['newClientReference'] == null ? undefined : json['newClientReference'],
    };
}

export function SetSupplierReferenceToJSON(value?: SetSupplierReference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'newClientReference': value['newClientReference'],
    };
}

